import React, { useState, useEffect } from 'react';
import './App.css';
import MusicStatus from './components/MusicStatus';
import FileUpload from './components/FileUpload';
import SongList from './components/SongList';
import Stats from './components/Stats';
import LoginForm from './components/LoginForm';
import { musicAPI } from './services/api';
import YouTubeUpload from './components/YouTubeUpload';

function App() {
  const [authenticated, setAuthenticated] = useState(!!localStorage.getItem('token'));
  const [status, setStatus] = useState(null);
  const [songs, setSongs] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('status');

  const handleLogout = () => {
    musicAPI.logout();
    setAuthenticated(false);
    // Reset all state when logging out
    setStatus(null);
    setSongs([]);
    setStats(null);
    setError(null);
  };

  // Set up the logout callback for the API
  useEffect(() => {
    musicAPI.setLogoutCallback(handleLogout);
  }, []);

  const fetchData = async () => {
    try {
      setError(null);
      const [statusData, songsData, statsData] = await Promise.all([
        musicAPI.getStatus(),
        musicAPI.getAllSongs(),
        musicAPI.getStats()
      ]);
      
      setStatus(statusData);
      setSongs(songsData);
      setStats(statsData);
    } catch (err) {
      setError(`Failed to fetch data: ${err.message}`);
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (authenticated) {
      fetchData();
      // const interval = setInterval(fetchData, 10000);
    
      // return () => clearInterval(interval);

    }
  }, [authenticated]);

  if (!authenticated) {
    return <LoginForm onLogin={() => setAuthenticated(true)} />;
  }

  if (loading && !status) {
    return (
      <div className="app">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="app-header">
        <h1>🎵 Somwaki Streamer</h1>
        <button
          className="refresh-btn"
          onClick={handleLogout}
        >
          Logout
        </button>
        <nav className="nav-tabs">
          <button 
            className={activeTab === 'status' ? 'active' : ''}
            onClick={() => setActiveTab('status')}
          >
            Status
          </button>
          <button 
            className={activeTab === 'songs' ? 'active' : ''}
            onClick={() => setActiveTab('songs')}
          >
            Songs
          </button>
          <button 
            className={activeTab === 'upload' ? 'active' : ''}
            onClick={() => setActiveTab('upload')}
          >
            Upload
          </button>
          <button 
            className={activeTab === 'youtube' ? 'active' : ''}
            onClick={() => setActiveTab('youtube')}
          >
            Youtube Links
          </button>
          <button 
            className={activeTab === 'stats' ? 'active' : ''}
            onClick={() => setActiveTab('stats')}
          >
            Stats
          </button>
        </nav>
      </header>

      <main className="app-main">
        {error && (
          <div className="error-message">
            {error}
            <button onClick={() => setError(null)}>×</button>
          </div>
        )}

        {activeTab === 'status' && (
          <MusicStatus 
            status={status}
            loading={loading}
            onRefresh={fetchData}
          />
        )}

        {activeTab === 'songs' && (
          <SongList 
            songs={songs}
            loading={loading}
            onDelete={async (id) => {
              await musicAPI.deleteSong(id);
              await fetchData();
            }}
          />
        )}

        {activeTab === 'upload' && (
          <FileUpload 
            onUpload={async (file) => {
              const result = await musicAPI.uploadFile(file);
              await fetchData();
              return result; // Return the result so the component can use it
            }}
            loading={loading}
          />
        )}

        {activeTab === 'youtube' && (
          <YouTubeUpload />
        )}

        {activeTab === 'stats' && (
          <Stats 
            stats={stats}
            loading={loading}
          />
        )}
      </main>
    </div>
  );
}

export default App;